import { getCareSourceRecordedAtMillis } from '../careSourceProcessing/careSourceStatusModel';
import { buildAppointmentDraftFromCareSources } from './appointmentCaptureSuggestion';
import { getCalendarDateKey } from '../../utils/calendarDateKey';

export const buildPendingAppointmentTimelineCandidates = (
  sources = [],
  { now = new Date(), timeZone = '' } = {}
) => sources.flatMap((source) => {
  const capturedAtMillis = getCareSourceRecordedAtMillis(source);
  const interpretationAnchor = capturedAtMillis ? new Date(capturedAtMillis) : now;
  const draft = buildAppointmentDraftFromCareSources([source], interpretationAnchor, timeZone);

  return draft && !draft.id ? [{
    ...draft,
    sourceId: source.id,
    capturedDate: capturedAtMillis ? getCalendarDateKey(new Date(capturedAtMillis)) : '',
  }] : [];
});

export const getPendingAppointmentsForDate = (candidates = [], dateKey = '') => (
  candidates.filter((candidate) => (candidate.capturedDate || candidate.date) === dateKey)
);

export const buildPendingAppointmentCalendarEntries = (candidates = []) => (
  candidates.filter((candidate) => candidate.capturedDate || candidate.date).map((candidate) => ({
    id: `pending-appointment-${candidate.sourceId}`,
    type: 'appointment',
    category: 'appointment',
    localDate: candidate.capturedDate || candidate.date,
    entryDayKey: candidate.capturedDate || candidate.date,
    timestamp: new Date(`${candidate.capturedDate || candidate.date}T12:00:00`),
  }))
);
